import AboutPage from '../../appModules/pages/about';
import SupportPage from '../../appModules/pages/support';
import SystemAvailabilityPage from '../../appModules/pages/systemAvailability';
/**
 * Application root level routes
 * @constant {Object}
 */
export const MainRoutes = Object.freeze({
    MONITORING: 'monitoring'
});
/**
 * Application Monitoring routes
 * @constant {Object}
 */
export var MonitoringRoutes;
(function (MonitoringRoutes) {
    MonitoringRoutes["MODELS"] = "models";
    MonitoringRoutes["OVERVIEW"] = "overview";
    MonitoringRoutes["MULTI_VIEW"] = "multi_view";
    MonitoringRoutes["EVENTS"] = "events";
})(MonitoringRoutes || (MonitoringRoutes = {}));
/**
 * Application Monitoring sub routes
 * @constant {Object}
 */
export const MonitoringSubRoutes = Object.freeze({
    ANALYSIS: 'analysis',
    VERSIONS: 'versions',
    HISTORY: 'history'
});
export const EventsSubRoutes = Object.freeze({
    NEW: 'new',
    MONITORING_WATCHLIST: 'monitoring_watchlist',
    READY_FOR_TRAINING: 'ready_for_training',
    TRAINED: 'trained',
    ARCHIVED: 'archived'
});
export const GenericMonitoringPath = `/${MainRoutes.MONITORING}/:page?/:id?/:subPage?/:subId?`;
/**
 * List of Application modules
 * @constant {Array}
 */
export const appsModules = Object.freeze([
    {
        link: `/${MainRoutes.MONITORING}`,
        text: 'IOC Event Monitoring',
        info: 'Event Monitoring application'
    }
]);
/**
 * List of Application Footer links
 * @constant {Array}
 */
export const links = Object.freeze([
    {
        href: `/about`,
        text: 'About',
        component: AboutPage
    },
    {
        href: `/support`,
        text: 'Support',
        component: SupportPage
    },
    {
        href: 'https://omnia-prevent.aurora.equinor.com',
        text: 'Documentation'
    },
    {
        href: `/system-availability`,
        text: 'System Availability',
        component: SystemAvailabilityPage
    }
]);
